import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import CalendarDefaultValue from '../../../../../components/CalendarDefaultValue';
import StepProgress from '../../../../../components/StepProgress';
import DataTableMui from '../../../../../components/DataTableMui';
import Button from '../../../../../components/Button';
import steps from '../../../../../utils/steps.json';

import { PageContainer, ContainerButton } from '../../../../../styles/styles';
import * as S from './styles';

import { useBeneficiarioEventual } from '../../../../../contexts/BeneficiarioEventual/context';
import { consultasMedicaPesquisar } from '../../../../../services';

function DadosMedicoConsulta() {
    const history = useHistory();
    const { periodoDia, localidade, dataEspecialidade, dataConsultaAtendimento } = useBeneficiarioEventual();

    const [dataTable, setDataTable] = useState([]);
    const [dateSelected, setDateSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const emptyMessage = 'Não encontramos horário diponivel com essa data. Você pode fazer uma nova pesquisa.';

    async function searchNewSchedule() {
        setLoading(true);

        const responseBusca = await consultasMedicaPesquisar(
            dataConsultaAtendimento.beneficiarioEventual.numCarteira,
            Number(dataEspecialidade.value),
            Number(localidade.value),
            moment(dateSelected).format('YYYY-MM-DD'),
            periodoDia.value
        );

        if (responseBusca.consultas) {
            setDataTable(responseBusca.consultas);
        } else {
            setDataTable([]);
        }

        setLoading(false);
        setAlreadySearched(true);
    }

    const columnsHead = [
        {
            key: 'data',
            selector: (row) => moment(row.data).format('DD/MM/YYYY - HH:mm') || '-',
            name: 'Data e Horário',
            sortable: true,
            direction: 'left',
        },
        {
            key: 'medico',
            selector: (row) => row.medico?.nome,
            name: 'Médico',
            sortable: true,
            direction: 'center',
        },
        {
            key: 'clinica',
            selector: (row) => row.estabelecimento?.nome,
            name: 'Clínica',
            sortable: true,
            direction: 'center',
        },
    ];

    async function handleClickRow(row) {
        history.push({
            pathname: '/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_confirmar_dados',
            dataBeneficiario: row,
        });
    }

    const rowMutation = {
        click: (row) => {
            handleClickRow(row);
        },
        hasClick: () => true,
    };

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.agendamentoConsulta} activeStep={4} />
                <S.ItemContainer>
                    <S.StylesCalendar>
                        <CalendarDefaultValue setDateSelected={setDateSelected} />
                    </S.StylesCalendar>
                    <S.SecondColumn>
                        <Button disabled={!dateSelected} type="primary" onClick={searchNewSchedule}>
                            Pesquisar
                        </Button>
                    </S.SecondColumn>
                </S.ItemContainer>

                <DataTableMui
                    clickableRow
                    rowMutation={rowMutation}
                    data={dataTable}
                    pointerOnHover
                    loading={loading}
                    emptyMessage={emptyMessage}
                    columns={columnsHead}
                    alreadySearched={alreadySearched}
                />
                <ContainerButton>
                    <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                        Voltar
                    </Button>
                </ContainerButton>
            </PageContainer>
        </>
    );
}

export default DadosMedicoConsulta;
